import React from "react";
import "./css/FeatureComingSoon.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faRocket } from "@fortawesome/free-solid-svg-icons";

function FeatureComingSoon({ featureName }) {
  return (
    <div className="feature-coming-soon">
      <div className="coming-soon-container">
        <div className="coming-soon-icon">
          <FontAwesomeIcon icon={faClock} />
        </div>
        <h2 className="coming-soon-title">
          {featureName ? `${featureName}` : "Feature"} Coming Soon
        </h2>
        <p className="coming-soon-message">
          This feature is currently under development and will be available in a
          future update.
        </p>
        <div className="coming-soon-details">
          <div className="detail-item">
            <FontAwesomeIcon icon={faRocket} className="detail-icon" />
            <span>We're working hard to bring you this feature</span>
          </div>
          <div className="detail-item">
            <FontAwesomeIcon icon={faClock} className="detail-icon" />
            <span>Check back soon for updates</span>
          </div>
        </div>
        <div className="coming-soon-footer">
          <p>
            Thank you for your patience as we continue to improve KinShield!
          </p>
        </div>
      </div>
    </div>
  );
}

export default FeatureComingSoon;
